<script setup lang="ts">
import { computed } from "vue";

import { useCondition } from "./useCondition";

import ConditionInputActivator from "./ConditionInputActivator.vue";
import ConditionInputTime from "./ConditionInputTime.vue";
import ConditionInputCompared from "./ConditionInputCompared.vue";
import ConditionInputOperator from "./ConditionInputOperator.vue";

interface Props {
  conditionId: number;
}
const props = defineProps<Props>();

const ctx = useCondition(() => props.conditionId);

const operatorsVisible = computed(() => {
  return ctx.activatorComplete;
});

const comparisonVisible = computed(() => {
  if (ctx.condition.activatorType == "roundRange") {
    return false;
  }
  if (ctx.condition.activatorType == null) {
    return false;
  }
  if (!ctx.operatorValid) {
    return false;
  }
  if (ctx.condition.activatorType == "round") {
    return true;
  }
  if (ctx.condition.activatorProperty == null) {
    return false;
  }
  return (
    ctx.activatorComplete &&
    ctx.condition.operator != "?" &&
    ctx.condition.operator != "!"
  );
});
</script>

<template>
  <div class="condition-input column">
    <h4 class="label mt-0 mb-3">{{ $t("labels.conditionActivator") }}</h4>
    <condition-input-activator :condition-id="conditionId" />

    <condition-input-time :condition-id="conditionId" />

    <template v-if="operatorsVisible">
      <hr />

      <condition-input-operator :condition-id="conditionId" />
    </template>

    <template v-if="comparisonVisible">
      <hr />

      <condition-input-compared :condition-id="conditionId" />
    </template>
  </div>
</template>

<style lang="scss">
.condition-input {
  display: block;
}
</style>
